import axios from "axios";
import axiosInstance from "./axiosInstance";
import { BASE_URL, BASE_URL_PREBID, TEST_URL_PREBID } from "./axios";

const BACKEND_URLS = [BASE_URL, BASE_URL_PREBID, TEST_URL_PREBID].filter(Boolean);

// A 401 here means bad credentials, not an expired session.
const AUTH_ENDPOINTS = [
  "/user/login",
  "/user/signup",
  "/forgot",
  "/reset",
  "/token",
];

let redirecting = false;

const isBackendRequest = (config) => {
  const rawUrl = String(config?.url || "");
  const url = /^https?:\/\//i.test(rawUrl)
    ? rawUrl
    : `${config?.baseURL || ""}${rawUrl}`;
  return BACKEND_URLS.some((base) => url.startsWith(base));
};

const isAuthEndpoint = (config) => {
  const url = String(config?.url || "").toLowerCase();
  return AUTH_ENDPOINTS.some((path) => url.includes(path));
};

const handleUnauthorized = (error) => {
  const { response, config } = error || {};
  if (
    response?.status === 401 &&
    !redirecting &&
    sessionStorage.getItem("access_token") &&
    isBackendRequest(config) &&
    !isAuthEndpoint(config) &&
    window.location.pathname !== "/login"
  ) {
    redirecting = true;
    sessionStorage.clear();
    window.location.assign("/login");
  }
  return Promise.reject(error);
};

export const installAuthInterceptor = () => {
  [axios, axiosInstance].forEach((client) => {
    client.interceptors.response.use((response) => response, handleUnauthorized);
  });
};
